import {Directive, ElementRef, HostListener, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
@Directive({
  selector: '[trim]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TrimDirective),
      multi: true,
    },
  ],
})
export class TrimDirective implements ControlValueAccessor {
  // value = '';
  constructor(private elementRef: ElementRef) {}
  private onChange: (value: string) => void;
  private onTouched: () => void;
  writeValue(v: string): void {
    // throw new Error('Method not implemented.');
    this.elementRef.nativeElement.value = v;
    // this.value = v;
  }
  registerOnChange(fn: (v: string) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }
  @HostListener('input')
  @HostListener('blur')
  @HostListener('focus')
  onInput() {
    const value: string = this.elementRef.nativeElement.value;
    this.elementRef.nativeElement.value = value.replace(/\s*/g, '');
    this.onChange(this.elementRef.nativeElement.value);
    // console.log(this.elementRef.nativeElement.value);
  }
}
